import React, { useCallback } from 'react';
import { Dropdown, MenuProps, Modal, Typography } from 'antd';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { DropdownIcon } from '../../assets/icons';
import { Script } from '../../types';
import { useNavigate } from 'react-router-dom';

interface Props {
  script: Script;
  onRemove: (scriptId: string) => void;
}

export const DropDown: React.FunctionComponent<Props> = ({ script, onRemove }) => {
  const navigate = useNavigate();

  const menuItems: MenuProps['items'] = [
    {
      label: <Typography className="normal-16 text-secondary">Edit script</Typography>,
      key: 'edit',
      icon: <EditOutlined className="normal-20 text-secondary" />,
      onClick: () => navigate(`/scripts/${script.script_id}`, { state: script })
    },
    {
      label: <Typography className="normal-16 text-red">Delete script</Typography>,
      key: 'delete',
      icon: <DeleteOutlined className="normal-20 text-red" />,
      onClick: () => handleRemove()
    }
  ];

  const handleRemove = useCallback(() => {
    Modal.confirm({
      title: 'Are you sure?',
      content: (
        <Typography className="regular-14">
          Please, confirm deleting <b>{script.script_name}</b> script
        </Typography>
      ),
      okText: 'Delete',
      closable: true,
      okButtonProps: { danger: true },
      onOk: () => script.script_id && onRemove(script.script_id)
    });
  }, [script, onRemove]);

  return (
    <Dropdown trigger={['click']} menu={{ items: menuItems }}>
      <DropdownIcon className="hint-color cursor-pointer" />
    </Dropdown>
  );
};
